import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { listStaff, createStaff, deleteMultipleStaff } from './services';

export const useStaffListQuery = () =>
  useQuery({
    queryKey: ['managemobi', 'staff', 'list'],
    queryFn: () => listStaff(),
    select: ({ data }) => data,
  });

export const useCreateStaffMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: data => createStaff(data),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['managemobi', 'staff', 'list'],
      });
    },
  });
};

export const useDeleteMultipleStaffMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: staffIds => deleteMultipleStaff(staffIds),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['managemobi', 'staff', 'list'],
      });
    },
  });
};
